import { render, staticRenderFns } from "./InformasiOrmas.vue?vue&type=template&id=64d9c409"
import script from "./InformasiOrmas.vue?vue&type=script&lang=js"
export * from "./InformasiOrmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports